/* eslint-disable react/react-in-jsx-scope */
import React from "react";
import { Box, Container, Typography } from "@mui/material";
import "./homepage-new.scss";
import StepCard from "../../common/components/step-card-component/step-card";

// data for carousel, card & stepCard sections
import { stepCardData } from "../../data/homepageData";

export default function FifthSectionHome() {
  return (
    <Box sx={{ py: 8, backgroundColor: "#f9f9f9", bgcolor: "#EAE7E7" }}>
      <Container maxWidth="lg">
        <Typography
          variant="h4"
          component="h2"
          sx={{
            textAlign: "center",
            fontWeight: 600,
            fontSize: { xs: "24px", md: "32px", lg: "34px" },
            lineHeight: { xs: "28px", md: "36px", lg: "40px" },
            color: "#104145",
          }}
        >
          How <span style={{ color: "#9F7F2C" }}>MemorialGo Works</span>
        </Typography>

        <Typography
          sx={{
            fontWeight: 400,
            fontSize: { xs: "22px", sm: "36px", md: "64px" },
            lineHeight: { xs: "120%", md: "100%" },
            textAlign: "center",
            color: "#104145",
            marginBottom: "3rem",
            marginTop: "1rem",
          }}
        >
          <span style={{ color: "#9F7F2C" }}>Guidance That Stays With You</span>
          , Every Step of the Way
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: { xs: 6, md: 4 },
            mt: { xs: 2, md: 0 },
          }}
        >
          {stepCardData?.map((card, index) => (
            <StepCard
              key={index}
              imageUrl={card.imageUrl}
              badgeText={card.badgeText}
              title={card.title}
              subtitle={card.subtitle}
            />
          ))}
        </Box>
      </Container>
    </Box>
  );
}
